import { render, staticRenderFns } from "./textfield.vue?vue&type=template&id=62a338e8&scoped=true&"
import script from "./textfield.vue?vue&type=script&lang=js&"
export * from "./textfield.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a338e8",
  null
  
)

export default component.exports